import React from 'react';
import { AppConfigApi } from '@/appConfig/AppConfigProvider.tsx';

export const AppConfig = React.createContext<AppConfigApi | null>(null);
